import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/document-services/page.tsx");
